module.exports = __webpack_public_path__ + "img/blfgc01_center_004.d9f93ea1.png";